<template>
    
    <!-- Encabezado de la Aplicación -->
    <div class="appHeader no-border">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Referir
        </div>
        <div class="right">
            <a href="#" class="headerButton" data-bs-toggle="modal" data-bs-target="#DialogBasic">Ayuda</a>
        </div>
    </div>
    <!-- * Encabezado de la Aplicación -->

    <!-- Diálogo Básico -->
    <div class="modal fade dialogbox" id="DialogBasic" data-bs-backdrop="static" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Verificación de Código QR</h5>
                </div>
                <div class="modal-body">
                    Puede usar la verificación de código QR para la autenticación de dos factores o proteger acciones.
                </div>
                <div class="modal-footer">
                    <div class="btn-inline">
                        <a href="#" class="btn btn-text-primary" data-bs-dismiss="modal">OK</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Diálogo Básico -->

    <!-- Cápsula de la Aplicación -->
    <div id="appCapsule">

        <div class="section">
            <div class="splash-page mt-5 mb-5">
                <div class="mb-3">
                    <img src="@/assets/img/sample/qr.png" alt="Código QR" class="imaged square w140">
                </div>
                <h2 class="mb-2">Escanea el Código QR</h2>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam aliquam.
                </p>
                <div class="form-group basic">
                    <label class="label">Enlace</label>
                    <div class="input-group mb-2">
                        <input type="text" class="form-control" readonly />
                    </div>
                </div>
            </div>
        </div>

        <div class="fixed-bar">
            <div class="row">
                <div class="col-12">
                    <a href="/" class="btn btn-lg btn-outline-secondary btn-block">Regresar</a>
                </div>
            </div>
        </div>

    </div>
    <!-- * Cápsula de la Aplicación -->

</template>